<div class="flex flex-row gap-4 items-center">
   <thk-ui-snippets [type]="'courseCover'" [imageUrl]="data.course_image" customClass="w-20 h-16 max-sm:w-16 max-sm:h-12">
   </thk-ui-snippets>
   <div class="flex flex-col gap-1">
      <h4 class="font-medium text-slate-800 text-lg max-sm:text-base">{{data.course_title}}</h4>
   </div>
</div>